function footBnOn(){
    //ページ最下層のバナーの出現位置
    let kids_design = document.getElementsByClassName('kids_design');
    let footer_zone = document.getElementsByClassName('footer_zone');
    let clientRect = kids_design[0].getBoundingClientRect();
    let allheight = window.scrollY + clientRect.top;
    window.addEventListener("scroll",()=>{
        if(window.scrollY>allheight){
            footer_zone[0].classList.add("active");
        } else {
            footer_zone[0].classList.remove("active");
        }
    },false)
}

window.addEventListener("load",()=>{
    footBnOn();
},false);


//フォームへのスクロールイベント
function scrollForm(button){
    button.addEventListener("click", function(e) {
        e.preventDefault();
        // スクロール先の要素を画面内に表示させる
        document.getElementById("form-body").scrollIntoView({
            behavior: "smooth"
        });
    });
}

let formLinkButton = document.getElementsByClassName("form_link_button");
for(let i=0;i<formLinkButton.length;i++){
    scrollForm(formLinkButton[i]);
}



